import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SquirrelEnvironmentDto } from 'projects/shared/src/lib/models/SquirrelEnvironmentDto';
import { DatabaseMigrationService } from 'projects/shared/src/lib/services/database-migration.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { DeleteSquirrelEnvironmentDialogComponent } from './delete-squirrel-environment-dialog/delete-squirrel-environment-dialog.component';
import { UpdateSquirrelEnvironmentDialogComponent } from './update-squirrel-environment-dialog/update-squirrel-environment-dialog.component';

@Component({
  selector: 'squirrel-environment-button-renderer',
  templateUrl: './squirrel-environment-button-renderer.component.html',
  styleUrls: ['./squirrel-environment-button-renderer.component.scss']
})
export class SquirrelEnvironmentButtonRendererComponent implements ICellRendererAngularComp {

  params: any;

  icon_edit!:string;
  icon_delete!:string; 

  constructor(public dialog: MatDialog,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private databaseMigrationService: DatabaseMigrationService) { }


  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;

    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.icon_edit = this.params.icon_edit || null;
    this.icon_delete = this.params.icon_delete || null;
    this.refresh(params);
  }

  deleteSquirrelEnvironmentDialog() {

    const rowData = [this.params.node.data]; 
    const envId = rowData[0].id;
    const envName = rowData[0].name

    const dialogRef = this.dialog.open(DeleteSquirrelEnvironmentDialogComponent, {width: '500px', data: {id: envId, name: envName}}); 

    dialogRef.afterClosed().subscribe({
      next:() => {
        this.params.api.refreshInfiniteCache();
      }
    });    
  }

  editSquirrelEnvironmentDialog() {

    const rowData = [this.params.node.data]; 

    let environmentDto = new SquirrelEnvironmentDto;
    environmentDto.id = rowData[0].id;
    environmentDto.migratedWhen = rowData[0].migratedWhen;
    environmentDto.name = rowData[0].name;
    environmentDto.numberOfMigrations =  rowData[0].numberOfMigrations;
    environmentDto.url = rowData[0].url;

    const dialogRef = this.dialog.open(UpdateSquirrelEnvironmentDialogComponent, {width: '800px', data: environmentDto});
    
    dialogRef.afterClosed().subscribe({
      next:() => {
        this.params.api.refreshInfiniteCache();
      }
    });
  }

 
}
